/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCodigoPostalCpt } from "../../api/getCodigoPostalCpt";
import Map, { Marker, GeolocateControl, Popup, NavigationControl } from 'react-map-gl';
import Header from "../../Header/Header";
import foodbrand from "../../assets/foodbrand@2x.png";
import "./styleDomPersonal.css";
import Select from 'react-select';
import html2canvas from "html2canvas";
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';

mapboxgl.workerClass = require("mapbox-gl/dist/mapbox-gl-csp-worker").default;

function ValidarUbicacion() {

    const [codigoPostal, setCodigoPostal] = useState("");
    const [validacionUbicacion, setValidacionUbicacion] = useState(false);
    const [blContinue, setBlContinue] = useState(true);
    const isRunned = useRef(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const MapaStyle = "mapbox://styles/mapbox/streets-v9";

    const [latitud_obtenid, setLatitudObj] = useState(0);
    const [longitud_obtenid, setLongitudObj] = useState(0);
    const [latitud, setLatitud] = useState(0);
    const [longitud, setLongitud] = useState(0);
    const [verMensajePermisos, setVerMensajePermisos] = useState(false);

    function aleatorio(inferior, superior) {
        var numPosibilidades = superior - inferior;
        var aleatorio = Math.random() * (numPosibilidades + 1);
        aleatorio = Math.floor(aleatorio);
        return inferior + aleatorio;
    }
    const varNumero = aleatorio(81, 95);
    const MAPBOX_TOKEN = 'pk.eyJ1IjoiamF2aWVyY2FtcG9zYW1icm9jaW8iLCJhIjoiY2wwaXJpNDcxMDA4bzNvb2VnMWQ0eTVzdCJ9.dOVWFy0U6H-fubygoxkgLQ';

    let inputElement = useRef(null)

    React.useEffect(() => {
        async function alidarDatosCalle() {
            if (latitud != 0 && longitud != 0) {

            } else {
                setVerMensajePermisos(true);
                setValidacionUbicacion(false);
                // console.log("No se pudo tener acceso a la geolocalizacion del dispositivo")
            }
        }
        alidarDatosCalle();

    }, []);



    React.useEffect(() => {

        /*if(tokenSesion===null || tokenSesion==="" || tokenSesion===undefined){
          cerrarSesion();
        }*/

        // console.log("==========================");
        // console.log(curpGlobal);
        // console.log(tokenSesion);
        // console.log(sEstudioGlobal);
        // console.log("==========================");

        async function getFuncionEstados() {
            /*así llamamos la función getCurrentPosition*/
            navigator.geolocation.getCurrentPosition(onSucccess, onError, config);
        }
        getFuncionEstados();

    }, []);


    const getContinue = async () => {

    };

    function onSucccess(position) {
        setLatitud(position.coords.latitude);
        setLongitud(position.coords.longitude);
    }

    /*se ejecuta si el permiso fue denegado o no se puede encontrar una ubicación*/
    function onError() {
        // console.log("ocurrio un error o no hay permisos para ver la ubicación");
    }

    var config = {
        enableHighAccuracy: true,
        maximumAge: 30000,
        timeout: 27000
    };

    const onMarkerDragStart = (event) => {
        logDragEvent('onDragStart', event);
    };

    const onMarkerDrag = (event) => {
        logDragEvent('onDrag', event);
    };

    const onMarkerDragEnd = (event) => {
        logDragEvent('onDragEnd', event);
        // setShowPopup(true);
        //let {lng,lat}= event.lngLat;

        // geolocalizacionInversa(lat,lng);
    };

    const { tipo } = useParams()

    /*Declaracion del formulario*/

    function logDragEvent(name, event) {
        //  console.log(event);
        let { lng, lat } = event.lngLat;
        // setLatitud(lat);
        setLatitudObj(lat);
        setLongitudObj(lng);
        setValidacionUbicacion(true);
        // setLatitudPaint(lat.toFixed(5));
        // setLongitudPaint(lng.toFixed(5));
        // setLongitud(lng);
        // console.log("lng: " + longitud + " " + "lat: " + latitud);
    }



    return (
        <>
            <div className="initBack_P2 animate__animated animate__fadeIn">
                <Header
                    imgBack={true}
                    rutaBack="/HomeDomPersonal"
                    title="Domicilio personal"
                    name="DataDomPersonal"
                />

                <div className="containerRender">
                    <div className="containerInfo_P2">
                        <div className="containerIdent_P2">
                            <div className="txtOp_P2">Dirección de referencia</div>
                            <div className="subTitle">Dirección laboral o donde normalmente despeña su actividad diaria.</div>
                            <hr className="separadorLine" />
                            <div>


                                <div id="captura">
                                    <Map ref={inputElement} initialViewState={{ longitude: longitud_obtenid, latitude: latitud_obtenid, zoom: 17, preserveDrawingBuffer: true }} mapboxAccessToken={MAPBOX_TOKEN}
                                        style={{ width: "100%", height: 450, marginLeft: 0 }} mapStyle={MapaStyle}>

                                        <Marker longitude={longitud_obtenid} latitude={latitud_obtenid} anchor="bottom" draggable
                                            onDragStart={onMarkerDragStart}
                                            onDrag={onMarkerDrag}
                                            onDragEnd={onMarkerDragEnd} >
                                        </Marker>
                                        <NavigationControl />
                                        { /*  <GeolocateControl /> */}
                                    </Map>
                                </div>


                            </div>
                            <hr className="line" />
                            <div className='btnContinue'>
                                {!blContinue ? (
                                    <>
                                        <button className='btnVer_P3'>
                                            <span className='txtVer_P3'>Continuar</span>
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button className='button_P2 animate__animated animate__fadeIn' type="submit" onClick={getContinue}>
                                            <span className='txtButton_P2'>Continuar</span>
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="imageContainer_P2">
                        <img src={foodbrand} className="imgFooter_P2" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ValidarUbicacion;
